import React, { FunctionComponent, useContext } from "react";
import { Theme, makeStyles, Grid, MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { UserDataContext } from "../context/user-data-context";
import { PresentationTextField } from "../../components/presentation-textfield";
import { DietPreference, Ethnicity, Gender } from "../../../../../api/smartmelts-api/graphql/generated";
import { PresentationNumberField } from "../../components/presentation-number-field";

const useStyles = makeStyles((theme: Theme) => ({
  fieldContainer: {
    paddingRight: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  dateField: {
    "& input::-webkit-date-and-time-value": {
      // Ios fix
      textAlign: "left",
    },
  },
  dateLabel: {
    color: theme.palette.common.black,
    fontWeight: 700,
  },
}));

interface IUserDataDigitalTwinInfoProps {}

export const UserDataDigitalTwinInfo: FunctionComponent<IUserDataDigitalTwinInfoProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    gender,
    setGender,
    dateOfBirth,
    setDateOfBirth,
    dateOfBirthDate,
    firstname,
    setFirstname,
    lastname,
    setLastname,
    weight,
    setWeight,
    weightValid,
    height,
    setHeight,
    heightValid,
    dietPreference,
    setDietPreference,
    dietPreferenceValid,
    ethnicity,
    setEthnicity,
    ethnicityValid,
  } = useContext(UserDataContext);

  return (
    <Grid container item xs={12} justify={"space-between"}>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          fullWidth
          select
          label={t("user_data.info.digital_twin_info.gender.label")}
          value={gender}
          onChange={(event) => setGender(event.target.value as Gender)}
          autoFocus
        >
          {Object.keys(Gender).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`gender.${Gender[key]}`)}
              </MenuItem>
            );
          })}
        </PresentationTextField>
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          className={classes.dateField}
          fullWidth
          label={t("user_data.info.digital_twin_info.date_of_birth.label")}
          id="user-data-date-of-birth"
          type="date"
          value={dateOfBirth}
          onChange={(event) => setDateOfBirth(event.target.value)}
          error={!dateOfBirthDate.isValid}
          autoFocus
          InputLabelProps={{ shrink: true, className: classes.dateLabel }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          fullWidth
          label={t("user_data.info.digital_twin_info.firstname.label")}
          value={firstname}
          onChange={(event) => setFirstname(event.target.value)}
          error={!firstname}
          autoFocus
        />
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          fullWidth
          label={t("user_data.info.digital_twin_info.lastname.label")}
          value={lastname}
          onChange={(event) => setLastname(event.target.value)}
          error={!lastname}
          autoFocus
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <PresentationNumberField
          label={t("user_data.info.digital_twin_info.weight.label")}
          fullWidth
          onChangeNumber={(value) => setWeight(value)}
          value={weight}
          error={!weightValid}
        />
      </Grid>
      <Grid item xs={6} className={classes.fieldContainer}>
        <PresentationNumberField
          label={t("user_data.info.digital_twin_info.height.label")}
          fullWidth
          onChangeNumber={(value) => setHeight(value)}
          autoFocus
          value={height}
          error={!heightValid}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          label={t("user_data.info.digital_twin_info.ethnicity.label")}
          fullWidth
          select
          id="user-data-ethnicity-select"
          value={ethnicity}
          error={!ethnicityValid}
          onChange={(event) => setEthnicity(event.target.value as Ethnicity)}
          autoFocus
        >
          {Object.keys(Ethnicity).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`ethnicity.${Ethnicity[key]}`)}
              </MenuItem>
            );
          })}
        </PresentationTextField>
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6} className={classes.fieldContainer}>
        <PresentationTextField
          label={t("user_data.info.digital_twin_info.diet_preference.label")}
          fullWidth
          select
          id="user-data-ethnicity-select"
          value={dietPreference}
          error={!dietPreferenceValid}
          onChange={(event) => setDietPreference(event.target.value as DietPreference)}
          autoFocus
        >
          {Object.keys(DietPreference).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`diet_preference.${DietPreference[key]}`)}
              </MenuItem>
            );
          })}
        </PresentationTextField>
      </Grid>
    </Grid>
  );
};
